import type { PropsWithChildren, Ref } from 'react'

interface HeaderBaseProps extends PropsWithChildren {
  ref?: Ref<HTMLElement>
}

export function HeaderBase({ children, ref }: HeaderBaseProps) {
  return (
    <nav ref={ref} className="top-0 z-10">
      <div className="text-background-secondary bg-[rgb(var(--background-header))] z-10 mx-auto flex h-[69px] w-full items-center justify-between gap-4 px-4 sm:px-6 md:px-14">
        {children}
      </div>
    </nav>
  )
}
